import type { TCascadeApi } from '@cascade/api-client/cascade-api';
import { createContext } from 'react';

export const ApiContext = createContext<TCascadeApi | undefined>(undefined);
